import "./paymentSucess.css";
import { GiConfirmed } from "react-icons/gi";
import { useNavigate } from "react-router-dom";

const PaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="paymentSuccess">
      <div className="paymentSuccess__container">
        <GiConfirmed className="paymentSuccess__container__icon" />
        <h1 className="paymentSuccess__container__header">Success!</h1>
        <h2>Your account is being upgraded!</h2>
        <p>
          Please allow a few minutes for your account to be updated. You will
          recieve email confirmation.
        </p>
        <button
          className="paymentSuccess__container__btn"
          onClick={() => {
            navigate("/dashboard");
          }}
        >
          Continue to Dashboard
        </button>
      </div>
      ;
    </div>
  );
};

export default PaymentSuccess;
